import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryShortcuts from "./components/CategoryShortcuts";
import FeaturedCarousel from "./components/FeaturedCarousel";
import LatestNews from "./components/LatestNews";
import HotForum from "./components/HotForum";
import RecentServices from "./components/RecentServices";
import IntroSection from "./components/IntroSection";

export default function Home() {
  useEffect(() => {
    document.title = "邻居-本地社区交流平台，打造和谐邻里关系";
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 w-full px-4 md:px-6 py-6 md:py-8 space-y-8 md:space-y-10">
        <div className="animate-fade-up">
          <HeroSection />
        </div>
        <CategoryShortcuts />
        <FeaturedCarousel />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="lg:col-span-2">
            <LatestNews />
          </div>
          <div>
            <HotForum />
          </div>
        </div>
        <RecentServices />
        <IntroSection />
      </main>
      <Footer />
    </div>
  );
}